var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    stroke: "#2C67F1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 25.2506H24.25M5.5 21.5006V11.5006M10.5 21.5006V11.5006M15.5 21.5006V11.5006M20.5 21.5006V11.5006M23 7.75056L13.53 1.83181C13.3377 1.71164 13.2416 1.65156 13.1385 1.62813C13.0473 1.60742 12.9527 1.60742 12.8615 1.62813C12.7584 1.65156 12.6623 1.71164 12.47 1.83181L3 7.75056H23Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinance);
export default __webpack_public_path__ + "static/media/finance.65d72ea942b6ebb8927c8eb737f64b2f.svg";
export { ForwardRef as ReactComponent };